export class RecoverPasswordDTO {
  constructor(
    public email: string
  ) {}
}
